<template>
  <AppContent v-if="!$auth.loading" />
</template>

<script>
import AppContent from './AppContent'

export default {
  name: 'App',

  components: {
    AppContent,
  },
}
</script>
